var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "addMarketing f16" },
    [
      _c("div", { staticClass: "lin_75 f18 gray_9 fb" }, [
        _vm._v("\n    营销策略 -\n    "),
        this.strategy === "DIRECT"
          ? _c("span", { staticClass: "gray_2" }, [_vm._v("手动发放")])
          : _vm._e(),
        this.strategy === "STRATEGY"
          ? _c("span", { staticClass: "gray_2" }, [_vm._v("策略发放")])
          : _vm._e()
      ]),
      _c("div", { staticClass: "b_white ps_main" }, [
        _c("p", { staticClass: "ps_main_head" }, [
          _vm._v(
            "温馨提示：为保障优惠券成功发放至用户账户，请保证优惠券发放数量充足"
          )
        ]),
        this.strategy === "STRATEGY"
          ? _c("div", { staticClass: "clear ps_search_wrap" }, [
              _c("span", { staticClass: "float-left marketing_head" }, [
                _vm._v("营销策略名称")
              ]),
              _c(
                "div",
                { staticClass: "ps_search float-left" },
                [
                  _c("el-input", {
                    attrs: {
                      type: "text",
                      placeholder: "请输入营销策略名称",
                      maxlength: "10",
                      "show-word-limit": ""
                    },
                    model: {
                      value: _vm.shopMarketing.marketingName,
                      callback: function($$v) {
                        _vm.$set(_vm.shopMarketing, "marketingName", $$v)
                      },
                      expression: "shopMarketing.marketingName"
                    }
                  })
                ],
                1
              )
            ])
          : _vm._e(),
        _c("div", { staticClass: "clear flex" }, [
          _c("span", { staticClass: "float-left marketing_head" }, [
            _vm._v("营销客户")
          ]),
          _c("div", { staticClass: "float-left client_list" }, [
            this.strategy === "STRATEGY"
              ? _c(
                  "div",
                  { staticClass: "lin_30" },
                  [
                    _c(
                      "el-radio-group",
                      {
                        on: { change: _vm.changeCustomerType },
                        model: {
                          value: _vm.shopMarketing.customerType,
                          callback: function($$v) {
                            _vm.$set(_vm.shopMarketing, "customerType", $$v)
                          },
                          expression: "shopMarketing.customerType"
                        }
                      },
                      [
                        _c("el-radio", { attrs: { label: "GROUPING" } }, [
                          _vm._v("按客户分组")
                        ]),
                        _c("el-radio", { attrs: { label: "CUSTOMER" } }, [
                          _vm._v("按指定客户")
                        ]),
                        _c("el-radio", { attrs: { label: "ALL" } }, [
                          _vm._v("所有人群")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            this.strategy === "DIRECT"
              ? _c(
                  "div",
                  { staticClass: "lin_30" },
                  [
                    _c(
                      "el-radio-group",
                      {
                        on: { change: _vm.changeCustomerType },
                        model: {
                          value: _vm.shopMarketing.customerType,
                          callback: function($$v) {
                            _vm.$set(_vm.shopMarketing, "customerType", $$v)
                          },
                          expression: "shopMarketing.customerType"
                        }
                      },
                      [
                        _c("el-radio", { attrs: { label: "GROUPING" } }, [
                          _vm._v("按客户分组")
                        ]),
                        _c("el-radio", { attrs: { label: "CUSTOMER" } }, [
                          _vm._v("按指定客户")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "ul",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.shopMarketing.customerType === "GROUPING",
                    expression: "shopMarketing.customerType === 'GROUPING'"
                  }
                ],
                staticClass: "clear"
              },
              [
                _c(
                  "el-checkbox-group",
                  {
                    staticClass: "flex flex_wrap",
                    attrs: { size: "small" },
                    on: { change: _vm.changeGroup },
                    model: {
                      value: _vm.checkGroupList,
                      callback: function($$v) {
                        _vm.checkGroupList = $$v
                      },
                      expression: "checkGroupList"
                    }
                  },
                  _vm._l(_vm.customerGroupList, function(group) {
                    return _c(
                      "el-checkbox",
                      {
                        key: group.id,
                        staticClass: "mar15_t",
                        attrs: { label: group, border: "" }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(group.name) +
                            "\n            "
                        )
                      ]
                    )
                  }),
                  1
                )
              ],
              1
            ),
            _c(
              "ul",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.shopMarketing.customerType === "CUSTOMER",
                    expression: "shopMarketing.customerType === 'CUSTOMER'"
                  }
                ],
                staticClass: "clear pad15_t"
              },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "mar10_l",
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.openCustomerPop()
                      }
                    }
                  },
                  [_vm._v("添加")]
                ),
                _c("div", { staticClass: "box20" }),
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { data: _vm.customerPop.customerSelList }
                  },
                  [
                    _c("el-table-column", {
                      attrs: { prop: "name", label: "客户名称", width: "300" }
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "phone", width: "260", label: "联系电话" }
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "groupName", label: "分组名称" }
                    }),
                    _c("el-table-column", {
                      attrs: { label: "操作" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "span",
                                {
                                  staticClass: "red cursor",
                                  on: {
                                    click: function($event) {
                                      return _vm.removeSelectCustomer(scope.row)
                                    }
                                  }
                                },
                                [_vm._v("删除")]
                              )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]),
        _c("div", { staticClass: "clear" }, [
          _c("span", { staticClass: "float-left marketing_head" }, [
            _vm._v("营销类型")
          ]),
          _c("div", { staticClass: "float-left coupon_list" }, [
            _c("p", { staticClass: "f14 lin_30" }, [
              _c("span", { staticClass: "pad20_r" }, [_vm._v("优惠券")]),
              _c(
                "span",
                {
                  staticClass: "c_blue cursor",
                  on: { click: _vm.chooseCoupon }
                },
                [_vm._v("添加")]
              )
            ]),
            _c("div", { staticClass: "box10" }),
            _c(
              "ul",
              { staticClass: "clear f12 white" },
              _vm._l(_vm.checkCouponList, function(coupon, index) {
                return _c("li", { key: coupon.regCode }, [
                  _c(
                    "div",
                    {
                      staticClass: "coupon_delete",
                      on: {
                        click: function($event) {
                          return _vm.removeCheckCoupon(index)
                        }
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "iconfont icon-iconfontshibai red f15"
                      })
                    ]
                  ),
                  _c("div", { staticClass: "clear coupon_price" }, [
                    _c("span", { staticClass: "float-left f24" }, [
                      _vm._v("￥" + _vm._s(coupon.regVal))
                    ]),
                    _c("div", { staticClass: "float-right t_right" }, [
                      _c("p", [
                        _vm._v("满" + _vm._s(coupon.regKey) + "元可用")
                      ]),
                      coupon.busType === "SHOP"
                        ? _c("p", [_vm._v("全部货品可用")])
                        : _vm._e(),
                      coupon.busType === "GOODS"
                        ? _c("p", [_vm._v("指定货品可用")])
                        : _vm._e(),
                      coupon.busType === "CATE"
                        ? _c("p", [_vm._v("指定分类可用")])
                        : _vm._e()
                    ])
                  ]),
                  _c("p", { staticClass: "t_center" }, [
                    _vm._v(
                      "领取时间：" +
                        _vm._s(coupon.startTimeStr) +
                        "至" +
                        _vm._s(coupon.endTimeStr)
                    )
                  ]),
                  _c("p", { staticClass: "t_center" }, [
                    _vm._v(
                      "使用时间：" +
                        _vm._s(coupon.useStartTimeStr) +
                        "至" +
                        _vm._s(coupon.useEndTimeStr)
                    )
                  ]),
                  _c("div", { staticClass: "clear coupon_num gray_3" }, [
                    _c("span", { staticClass: "float-left" }, [
                      _vm._v("数量："),
                      _c("em", { staticClass: "red" }, [
                        _vm._v(_vm._s(coupon.surplusNum))
                      ])
                    ]),
                    coupon.residueEndDay
                      ? _c("span", { staticClass: "float-right" }, [
                          _vm._v("即将到期")
                        ])
                      : _vm._e()
                  ]),
                  _vm.shopMarketing.customerType === "GROUPING" &&
                  coupon.surplusNum < _vm.checkGroupMemberNum
                    ? _c(
                        "p",
                        { staticClass: "f14", staticStyle: { color: "black" } },
                        [
                          _vm._v(
                            "\n              优惠券数量小于分组总人数（" +
                              _vm._s(_vm.checkGroupMemberNum) +
                              "）"
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.shopMarketing.customerType === "GROUPING" &&
                  coupon.surplusNum >= _vm.checkGroupMemberNum
                    ? _c(
                        "p",
                        { staticClass: "f14", staticStyle: { color: "black" } },
                        [
                          _vm._v(
                            "\n              分组总人数（" +
                              _vm._s(_vm.checkGroupMemberNum) +
                              "）"
                          )
                        ]
                      )
                    : _vm._e()
                ])
              }),
              0
            )
          ])
        ]),
        this.strategy === "DIRECT"
          ? _c("div", { staticClass: "clear mar30_b" }, [
              _c("span", { staticClass: "float-left marketing_head" }, [
                _vm._v("发放")
              ]),
              _vm._m(0)
            ])
          : _vm._e(),
        this.strategy === "STRATEGY"
          ? _c("div", { staticClass: "clear condition_set mar30_b" }, [
              _c("span", { staticClass: "float-left marketing_head" }, [
                _vm._v("条件设置")
              ]),
              _c("div", { staticClass: "float-left f14" }, [
                _c(
                  "div",
                  [
                    _c(
                      "el-radio-group",
                      {
                        staticClass: "radio-block",
                        on: { change: _vm.strategyChange },
                        model: {
                          value: _vm.strategyType,
                          callback: function($$v) {
                            _vm.strategyType = $$v
                          },
                          expression: "strategyType"
                        }
                      },
                      [
                        _c(
                          "el-radio",
                          { attrs: { label: "ORDER_AMOUNT" } },
                          [
                            _c("span", [_vm._v("根据金额发放")]),
                            _vm.shopMarketing.strategyCondition ===
                              "ORDER_AMOUNT" &&
                            _vm.shopMarketing.strategyRule !== "TOTAL"
                              ? [
                                  _c(
                                    "span",
                                    { staticClass: "mar20-l gray6" },
                                    [
                                      _vm._v(
                                        "\n                一笔订单，金额满\n                "
                                      ),
                                      _c("el-input-number", {
                                        attrs: {
                                          size: "mini",
                                          precision: 2,
                                          step: 1,
                                          min: 1
                                        },
                                        model: {
                                          value:
                                            _vm.shopMarketing
                                              .operatorAmountQuantity,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.shopMarketing,
                                              "operatorAmountQuantity",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "shopMarketing.operatorAmountQuantity"
                                        }
                                      }),
                                      _vm._v(" 元\n              ")
                                    ],
                                    1
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "mar20-l gray6" },
                                    [
                                      _vm._v(
                                        "\n                是否开启叠加发放\n                "
                                      ),
                                      _c("el-switch", {
                                        staticClass: "mar10-l",
                                        attrs: {
                                          "active-value": "OVERLAY",
                                          "inactive-value": "ONCE",
                                          "active-color": "#ff0023",
                                          "inactive-color": "#999"
                                        },
                                        model: {
                                          value: _vm.shopMarketing.strategyRule,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.shopMarketing,
                                              "strategyRule",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "shopMarketing.strategyRule"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              : _vm._e()
                          ],
                          2
                        ),
                        _c(
                          "el-radio",
                          { attrs: { label: "ORDER_QUANTITY" } },
                          [
                            _c("span", [_vm._v("根据数量发放")]),
                            _vm.shopMarketing.strategyCondition ===
                              "ORDER_QUANTITY" &&
                            _vm.shopMarketing.strategyRule !== "TOTAL"
                              ? [
                                  _c(
                                    "span",
                                    { staticClass: "mar20-l gray6" },
                                    [
                                      _vm._v(
                                        "\n                一笔订单，数量满 "
                                      ),
                                      _c("el-input-number", {
                                        attrs: {
                                          size: "mini",
                                          precision: 2,
                                          step: 1,
                                          min: 1
                                        },
                                        model: {
                                          value:
                                            _vm.shopMarketing
                                              .operatorAmountQuantity,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.shopMarketing,
                                              "operatorAmountQuantity",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "shopMarketing.operatorAmountQuantity"
                                        }
                                      }),
                                      _vm._v(" 件\n                ")
                                    ],
                                    1
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "mar20-l gray6" },
                                    [
                                      _vm._v(
                                        "\n                  是否开启叠加发放\n                  "
                                      ),
                                      _c("el-switch", {
                                        staticClass: "mar10-l",
                                        attrs: {
                                          "active-value": "OVERLAY",
                                          "inactive-value": "ONCE",
                                          "active-color": "#ff0023",
                                          "inactive-color": "#999"
                                        },
                                        model: {
                                          value: _vm.shopMarketing.strategyRule,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.shopMarketing,
                                              "strategyRule",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "shopMarketing.strategyRule"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              : _vm._e()
                          ],
                          2
                        ),
                        _c("el-radio", { attrs: { label: "TOTAL" } }, [
                          _vm._v("累计发放")
                        ])
                      ],
                      1
                    ),
                    _vm.shopMarketing.strategyRule === "TOTAL"
                      ? _c(
                          "el-radio-group",
                          {
                            staticClass: "radio-block mar30-l",
                            on: { change: _vm.strategyTotalChange },
                            model: {
                              value: _vm.strategyTotalType,
                              callback: function($$v) {
                                _vm.strategyTotalType = $$v
                              },
                              expression: "strategyTotalType"
                            }
                          },
                          [
                            _c(
                              "el-radio",
                              { attrs: { label: "ORDER_AMOUNT" } },
                              [
                                _c("span", [_vm._v("按照消费金额")]),
                                _c(
                                  "span",
                                  { staticClass: "mar20-l gray6" },
                                  [
                                    _vm._v(
                                      "\n                有效期内累计消费满 "
                                    ),
                                    _c("el-input-number", {
                                      attrs: {
                                        size: "mini",
                                        precision: 2,
                                        step: 1,
                                        min: 1
                                      },
                                      model: {
                                        value:
                                          _vm.shopMarketing
                                            .operatorAmountQuantity,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.shopMarketing,
                                            "operatorAmountQuantity",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "shopMarketing.operatorAmountQuantity"
                                      }
                                    }),
                                    _vm._v(" 元\n              ")
                                  ],
                                  1
                                )
                              ]
                            ),
                            _c(
                              "el-radio",
                              { attrs: { label: "ORDER_QUANTITY" } },
                              [
                                _c("span", [_vm._v("按商品发放")]),
                                _c(
                                  "span",
                                  { staticClass: "mar20-l gray6" },
                                  [
                                    _vm._v(
                                      "\n                有效期内累计商品交易 "
                                    ),
                                    _c("el-input-number", {
                                      attrs: {
                                        size: "mini",
                                        precision: 2,
                                        step: 1,
                                        min: 1
                                      },
                                      model: {
                                        value:
                                          _vm.shopMarketing
                                            .operatorAmountQuantity,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.shopMarketing,
                                            "operatorAmountQuantity",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "shopMarketing.operatorAmountQuantity"
                                      }
                                    }),
                                    _vm._v(" 件\n              ")
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "lin_30" },
                  [
                    _c(
                      "el-radio-group",
                      {
                        model: {
                          value: _vm.shopMarketing.strategyGoods,
                          callback: function($$v) {
                            _vm.$set(_vm.shopMarketing, "strategyGoods", $$v)
                          },
                          expression: "shopMarketing.strategyGoods"
                        }
                      },
                      [
                        _c("el-radio", { attrs: { label: "ALL" } }, [
                          _vm._v("全部货品")
                        ]),
                        _c("el-radio", { attrs: { label: "APPOINT" } }, [
                          _vm._v("指定货品")
                        ])
                      ],
                      1
                    ),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.shopMarketing.strategyGoods === "APPOINT",
                            expression:
                              "shopMarketing.strategyGoods === 'APPOINT'"
                          }
                        ],
                        staticClass: "pad15_l c_blue cursor",
                        on: {
                          click: function($event) {
                            return _vm.selectGoodsList("GOODS")
                          }
                        }
                      },
                      [_vm._v("添加货品")]
                    ),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.shopMarketing.strategyGoods === "APPOINT",
                            expression:
                              "shopMarketing.strategyGoods === 'APPOINT'"
                          }
                        ],
                        staticClass: "pad15_l c_blue cursor",
                        on: {
                          click: function($event) {
                            return _vm.selectGoodsList("DEALER")
                          }
                        }
                      },
                      [_vm._v("添加代销货品")]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.shopMarketing.strategyGoods === "APPOINT",
                        expression: "shopMarketing.strategyGoods === 'APPOINT'"
                      }
                    ]
                  },
                  [
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { data: _vm.checkGoodsList }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "name",
                            label: "商品名称",
                            width: "300"
                          }
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "marketPriceStr",
                            width: "260",
                            label: "价格"
                          }
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "statusName", label: "状态" }
                        }),
                        _c("el-table-column", {
                          attrs: { label: "操作" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "red cursor",
                                        on: {
                                          click: function($event) {
                                            return _vm.removeCheckGoods(
                                              scope.row.goodsId
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("删除")]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1192625790
                          )
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ])
          : _vm._e(),
        this.strategy === "STRATEGY"
          ? _c("div", { staticClass: "clear pad100-l mar30-l mar30_b" }, [
              _c("span", { staticClass: "float-left" }, [_vm._v("有效期：")]),
              _c(
                "div",
                { staticClass: "float-left f14" },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      "picker-options": _vm.pickerOptions
                    },
                    model: {
                      value: _vm.selectDate,
                      callback: function($$v) {
                        _vm.selectDate = $$v
                      },
                      expression: "selectDate"
                    }
                  })
                ],
                1
              )
            ])
          : _vm._e(),
        this.strategy === "STRATEGY" && this.strategyType != "TOTAL"
          ? _c("div", { staticClass: "clear flex" }, [
              _c("span", { staticClass: "float-left marketing_head" }, [
                _vm._v("发放方式")
              ]),
              _c("div", { staticClass: "float-left client_list" }, [
                _c(
                  "div",
                  { staticClass: "lin_30" },
                  [
                    _c(
                      "el-radio-group",
                      {
                        model: {
                          value: _vm.shopMarketing.marketingGrantType,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.shopMarketing,
                              "marketingGrantType",
                              $$v
                            )
                          },
                          expression: "shopMarketing.marketingGrantType"
                        }
                      },
                      [
                        _c("el-radio", { attrs: { label: "1" } }, [
                          _vm._v("支付完成后发放")
                        ]),
                        _c("el-radio", { attrs: { label: "2" } }, [
                          _vm._v("卖家发货后发放")
                        ]),
                        _c("el-radio", { attrs: { label: "3" } }, [
                          _vm._v("确认收货后发放")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ])
          : _vm._e(),
        _c(
          "div",
          { staticClass: "marking_btn" },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary" },
                on: { click: _vm.submitMarketingBefore }
              },
              [_vm._v("确 认")]
            ),
            _c(
              "router-link",
              { attrs: { to: "/mj/marketingList" } },
              [_c("el-button", [_vm._v("取 消")])],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择商品",
            visible: _vm.chooseGoodVisible,
            "close-on-click-modal": false,
            width: "1140px",
            top: "80px",
            "show-close": false,
            "custom-class": "chooseGoodPop"
          },
          on: {
            "update:visible": function($event) {
              _vm.chooseGoodVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "clear ps_search_wrap" }, [
            _c(
              "span",
              { staticClass: "float-left pad15_r lin_30 inlineblock" },
              [_vm._v("货品名称")]
            ),
            _c(
              "div",
              { staticClass: "ps_search float-left" },
              [
                _c("el-input", {
                  attrs: { type: "text", placeholder: "请输入货品名称" },
                  model: {
                    value: _vm.searchGoods.name,
                    callback: function($$v) {
                      _vm.$set(_vm.searchGoods, "name", $$v)
                    },
                    expression: "searchGoods.name"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "float-left client_pop_query",
                on: {
                  click: function($event) {
                    return _vm.listShopGoods()
                  }
                }
              },
              [_vm._v("搜索")]
            )
          ]),
          _c("div", { staticClass: "box30" }),
          _c(
            "el-table",
            {
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.goodsDataList,
                "row-key": "goodsId",
                height: "289"
              },
              on: { "selection-change": _vm.goodsDialogSelect }
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "selection",
                  "reserve-selection": true,
                  width: "55"
                }
              }),
              _c("el-table-column", {
                attrs: { prop: "name", label: "商品名称", width: "400" }
              }),
              _c("el-table-column", {
                attrs: { prop: "marketPriceStr", width: "200", label: "价格" }
              }),
              _vm.goodsSelType !== "GOODS"
                ? _c("el-table-column", {
                    attrs: { prop: "shopName", label: "店铺名称" }
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { prop: "statusName", label: "状态" }
              })
            ],
            1
          ),
          _c("div", { staticClass: "box15" }),
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.currentPage,
              "page-sizes": [10, 20, 30],
              "page-size": _vm.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.totalCount
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.goodsDialogConfirm }
                },
                [_vm._v("确 认")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.chooseGoodVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择优惠券",
            visible: _vm.chooseCouponVisible,
            "close-on-click-modal": false,
            width: "540px",
            top: "120px",
            "show-close": false,
            "custom-class": "chooseCouponPop"
          },
          on: {
            "update:visible": function($event) {
              _vm.chooseCouponVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "coupon_list" }, [
            _c(
              "ul",
              { staticClass: "clear f12 white" },
              _vm._l(_vm.shopCouponList, function(coupon) {
                return coupon.surplusNum > 0
                  ? _c(
                      "li",
                      {
                        key: coupon.regCode,
                        class: { coupon_check: coupon.isCheck },
                        on: {
                          click: function($event) {
                            return _vm.checkCoupon(coupon)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "clear coupon_price" }, [
                          _c("span", { staticClass: "float-left f24" }, [
                            _vm._v("￥" + _vm._s(coupon.regVal))
                          ]),
                          _c(
                            "span",
                            { staticClass: "float-left pad5_l lin_35" },
                            [_vm._v("满" + _vm._s(coupon.regKey))]
                          )
                        ]),
                        _c("p", { staticClass: "pad20_l f14" }, [
                          _vm._v("有效期至" + _vm._s(coupon.endTimeStr))
                        ]),
                        _c("div", { staticClass: "box15" }),
                        _c("div", { staticClass: "clear coupon_num gray_3" }, [
                          coupon.busType === "SHOP"
                            ? _c("span", { staticClass: "float-left" }, [
                                _vm._v("全部货品可用")
                              ])
                            : coupon.busType === "GOODS"
                            ? _c("span", { staticClass: "float-left" }, [
                                _vm._v("指定货品可用")
                              ])
                            : coupon.busType === "CATE"
                            ? _c("span", { staticClass: "float-left" }, [
                                _vm._v("指定分类可用")
                              ])
                            : _vm._e()
                        ])
                      ]
                    )
                  : _vm._e()
              }),
              0
            )
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmCheckCoupon }
                },
                [_vm._v("确 定")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.chooseCouponVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: { title: "提示", visible: _vm.confirmDialog, width: "20%" },
          on: {
            "update:visible": function($event) {
              _vm.confirmDialog = $event
            }
          }
        },
        [
          _c("p", [_vm._v("优惠券即将到期或剩余数量小于用户总人数")]),
          _c("p", [_vm._v("请确认是否创建此营销活动")]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.confirmDialog = false
                    }
                  }
                },
                [_vm._v("暂不创建")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.submitMarketing }
                },
                [_vm._v("确定创建")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择客户",
            visible: _vm.customerPop.chooseClientVisible,
            "close-on-click-modal": false,
            width: "800px",
            "show-close": false,
            "custom-class": "chooseClientPop"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.customerPop, "chooseClientVisible", $event)
            }
          }
        },
        [
          _c("div", [
            _c("div", { staticClass: "clear ps_search_wrap" }, [
              _c(
                "span",
                {
                  staticClass: "float-left pad15_r lin_30 inlineblock",
                  staticStyle: { "padding-right": "25px" }
                },
                [_vm._v("客户名称")]
              ),
              _c(
                "div",
                { staticClass: "ps_search float-left" },
                [
                  _c("el-input", {
                    attrs: { type: "text", placeholder: "请输入客户名称" },
                    model: {
                      value: _vm.customerPop.searchCustomer.name,
                      callback: function($$v) {
                        _vm.$set(_vm.customerPop.searchCustomer, "name", $$v)
                      },
                      expression: "customerPop.searchCustomer.name"
                    }
                  })
                ],
                1
              )
            ]),
            _c(
              "div",
              {
                staticClass: "clear ps_search_wrap",
                staticStyle: { "padding-top": "10px" }
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "float-left pad15_r lin_30 inlineblock",
                    staticStyle: { "padding-right": "11px" }
                  },
                  [_vm._v("客户手机号")]
                ),
                _c(
                  "div",
                  { staticClass: "ps_search float-left" },
                  [
                    _c("el-input", {
                      attrs: { type: "text", placeholder: "请输入客户手机号" },
                      model: {
                        value: _vm.customerPop.searchCustomer.phone,
                        callback: function($$v) {
                          _vm.$set(_vm.customerPop.searchCustomer, "phone", $$v)
                        },
                        expression: "customerPop.searchCustomer.phone"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "float-left client_pop_query",
                    on: {
                      click: function($event) {
                        return _vm.listCustomer(1)
                      }
                    }
                  },
                  [_vm._v("搜索")]
                )
              ]
            ),
            _c("div", { staticClass: "box30" }),
            _c("div", { staticClass: "clear ps_search_wrap" }, [
              _c(
                "span",
                { staticClass: "float-left pad15_r lin_30 inlineblock" },
                [_vm._v("客户分组")]
              ),
              _c(
                "div",
                { staticClass: "ps_search float-left" },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择客户分组", clearable: "" },
                      model: {
                        value: _vm.customerPop.searchCustomer.groupId,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.customerPop.searchCustomer,
                            "groupId",
                            $$v
                          )
                        },
                        expression: "customerPop.searchCustomer.groupId"
                      }
                    },
                    _vm._l(_vm.customerGroupList, function(item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ]),
            _c("div", { staticClass: "box20" }),
            _c("div", { staticClass: "clear ps_group_list" }, [
              _c("div", { staticClass: "float-left client_list_all" }, [
                _c("p", [_vm._v("我的客户")]),
                _c("div", { staticClass: "client_list_pop_main" }, [
                  _c(
                    "ul",
                    { staticClass: "clear" },
                    _vm._l(_vm.customerPop.customerDataList, function(
                      item,
                      index
                    ) {
                      return _c(
                        "li",
                        {
                          key: index,
                          on: {
                            click: function($event) {
                              return _vm.customerDialogSelect(item)
                            }
                          }
                        },
                        [
                          _c(
                            "p",
                            { staticClass: "group_item_name ellipsis_two" },
                            [_vm._v(_vm._s(item.name))]
                          ),
                          _c("p", [
                            _vm._v(
                              "身份：" +
                                _vm._s(item.targetType === 1 ? "个人" : "企业")
                            )
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ])
              ]),
              _c("div", { staticClass: "float-right client_list_me" }, [
                _c("p", [_vm._v("已选客户")]),
                _c("div", { staticClass: "client_list_pop_main" }, [
                  _c(
                    "ul",
                    { staticClass: "clear" },
                    _vm._l(_vm.customerPop.customerSelList, function(
                      item,
                      index
                    ) {
                      return _c("li", { key: index }, [
                        _c("i", {
                          staticClass: "iconfont icon-shibai fb",
                          on: {
                            click: function($event) {
                              return _vm.removeSelectCustomer(item)
                            }
                          }
                        }),
                        _c(
                          "p",
                          { staticClass: "group_item_name ellipsis_two" },
                          [_vm._v(_vm._s(item.name))]
                        ),
                        _c("p", [
                          _vm._v(
                            "身份：" +
                              _vm._s(item.targetType === 1 ? "个人" : "企业")
                          )
                        ])
                      ])
                    }),
                    0
                  )
                ])
              ])
            ])
          ]),
          _c("div", { staticClass: "box20" }),
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.customerPop.currentPageCustomer,
              "page-sizes": [10, 20, 30],
              "page-size": _vm.customerPop.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.customerPop.totalCount
            },
            on: {
              "size-change": _vm.handleSizeChangeCustomer,
              "current-change": _vm.handleCurrentChangeCustomer
            }
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.customerDialogConfirm }
                },
                [_vm._v("确 认")]
              ),
              _c("el-button", { on: { click: _vm.customerDialogClose } }, [
                _vm._v("取 消")
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "float-left f14" }, [
      _c("p", { staticClass: "lin_30" }, [_vm._v("直接发放至用户的账户")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }